import React, { useState } from 'react';
import './App.css';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme'; 
import MatriculaForm from './components/MatriculaForm';
import ErrorModal from './components/ErrorModal';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
    const [errorMessage, setErrorMessage] = useState(null);
    const searchParams = new URLSearchParams(window.location.search);
    const token = searchParams.get('token');

    const handleError = (message) => {
        setErrorMessage(message);
    };

    return (
        <ErrorBoundary>
        <ThemeProvider theme={theme}>
            {errorMessage ? (
                <ErrorModal message={errorMessage} />
            ) : (
                <MatriculaForm token={token} onError={handleError} />
            )}
        </ThemeProvider>
        </ErrorBoundary>
    );
}

export default App;
